import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { ArrowLeft } from "lucide-react";
 * // Use <ArrowLeft /> instead
 */
export const ArrowLeftIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M11.7071 5.70711C12.0976 5.31658 12.0976 4.68342 11.7071 4.29289C11.3166 3.90237 10.6834 3.90237 10.2929 4.29289L3.29289 11.2929C2.90237 11.6834 2.90237 12.3166 3.29289 12.7071L10.2929 19.7071C10.6834 20.0976 11.3166 20.0976 11.7071 19.7071C12.0976 19.3166 12.0976 18.6834 11.7071 18.2929L6.41423 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H6.4142L11.7071 5.70711Z"
  />
);
